module.exports = "<p>\r\n  print-full-page works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/print-full-page/print-full-page.component.html
// module id = 743
// module chunks = 0